import SeeAllPlatinumNightsCard from './SeeAllPlatinumNightsCard';

export default SeeAllPlatinumNightsCard;
